import { render, staticRenderFns } from "./pieces.vue?vue&type=template&id=0cb7a030&scoped=true"
import script from "./pieces.vue?vue&type=script&lang=js"
export * from "./pieces.vue?vue&type=script&lang=js"
import style0 from "./pieces.vue?vue&type=style&index=0&id=0cb7a030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb7a030",
  null
  
)

export default component.exports